import React from 'react';
import Fromcompanynew from '../../../components/formularios/Fromcompany/Fromcompanynew.jsx';
import Fromcompanywiew from '../../../components/formularios/Fromcompany/Fromcompanywiew.jsx';


import { useSelector} from 'react-redux';
// import {OpcionesLaterales} from './OpcionesLaterales'
import {
  Avatar,
  Box,
  Card,
  CardActions,
  CardContent,
  Divider,
  Typography
} from '@mui/material';
import { Grid } from 'semantic-ui-react';
import FileUploadRut from '../../../components/formularios/FrmsUpFiles/FileUploadRut.jsx';
import FileUploadDocComercio from '../../../components/formularios/FrmsUpFiles/FileUploadDocComercio.jsx';
import FileUploadDocSii from '../../../components/formularios/FrmsUpFiles/FileUploadDocSii.jsx';
import FileUploadDocEbiexComercio from '../../../components/formularios/FrmsUpFiles/FileUploadDocEbiexComercio.jsx';
import FileUploadPatente from '../../../components/formularios/FrmsUpFiles/FileUploadPatente.jsx';
import FileUploadLogo from '../../../components/formularios/FrmsUpFiles/FileUploadLogo.jsx';
import useGlobalConfig from '../../../hooks/globalConfig.js';
import useObtenerDatosdeCliente from '../../../hooks/obtenerDatosdeCliente.js';


const Companies = (props ) => {
  const {siteName} = useGlobalConfig()
  const userUid = useSelector(store => store.usuario.user.uid)
  const[authorized, setAuthorized] = React.useState(false)
  //Buscar Valores por defecto
  const {userdata, data, loadingDatosdeCliente, errorDatosdeCliente } = useObtenerDatosdeCliente(userUid)//(userUid)

  const [ChildTrigres, setChildTrigres] = React.useState(true);
  const togglechildtrigres = () => {
    // console.log('reset')   
    function delay() {
      props.history.push('/dashboard/mi-cuenta')
    }
    setTimeout(delay, 2000);
  
  };


  // console.log(data)
  // console.log(userdata)

  React.useEffect(()=>{
    console.log(data)
    if(userdata){

    if(userdata.userCompanyID){
      // console.log('COMPAÑIA ACTIVA')
      // console.log(userdata.userCompanyID)
    }
    if(userdata.userCompanyRoll === `${process.env.REACT_APP_ADMIN}`){
      setAuthorized(true)
    }
    if(userdata.userCompanyRoll === `${process.env.REACT_APP_ADMIN_COMPANY}`){
      setAuthorized(true)
    }
    if(userdata.userCompanyRoll === `${process.env.REACT_APP_ADMIN_XPRESS}`){
      setAuthorized(true)
    }
   
     }
  },[userdata, ChildTrigres])

  return (    
    <Grid celled='internally'  id='mi-cuentaContent'>
      <div><h2>Mi Empresa</h2></div>
    <Grid.Row> 
    <Grid.Column  computer={3} mobile={16} tablet={16}  id='mi-cuentaContainer' >
    <Card >
    <CardContent>
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {
          data?( <><Avatar
            src={data.companyImgLogo} // Logo de empresa
            sx={{
              height: 64,
              mb: 2,
              width: 64
            }}
          /></>):(<></>)
        }
       
        <Typography
          color="textPrimary"
          gutterBottom
          variant="h5"
        >
          {
            data?(<span>{data.companyName}</span>):('Sin registro')
          }
          
        </Typography>
        <Typography
          color="textSecondary"
          variant="body2"
        > 
        {
          data?(<span>{data.companyCity}</span>):('Sin registro')
        }
          
        </Typography>
      </Box>
    </CardContent>
    <Divider />
    <CardActions>

    </CardActions>
    </Card> 
    <Card >
      <h3>Datos de facturación</h3>
    {
            data?(
    <CardContent>
      <Box
        sx={{
          alignItems: 'left',
          display: 'flex',
          flexDirection: 'column'
        }}
      >

        <Divider />
        <Typography
          color="textSecondary"
          variant="body2">
          {
              data.isActive===true?(<>Activo</>):(<><i className="exclamation circle icon alert-danger"> </i>Activación en espera.. Puede solicitar revisión en soporte </>) 
          }
        </Typography>
        <Divider />
        <Typography
          color="textSecondary"
          variant="body2">
            {
              data.statusDocsRut===true?(<span><i className="check circle icon alert-success" ></i> RUT</span>):(<span><i className="exclamation circle icon alert-warning"></i> RUT</span>)
            } 
        </Typography>
        <Divider />
        <Typography
          color="textSecondary"
          variant="body2">
            {
              data.statusDocsComercio?(<span><i className="check circle icon alert-success" ></i> Documento Constitutivo</span>):(<span><i className="exclamation circle icon alert-warning"></i> Si es necesario Documento Constitutivo</span>)
            }
        </Typography>
        <Divider />
        <Typography
          color="textSecondary"
          variant="body2">
            {
              data.statusDocsDocsii?(<span><i className="check circle icon alert-success" ></i> Documento SII</span>):(<span> <i className="exclamation circle icon alert-warning"></i> Documento SII</span>)
            }
        </Typography>
        <Divider />
        <Typography
          color="textSecondary"
          variant="body2"> Acuerdo comercial
            {
              data.statusDocsAcuerdo?(<span><br></br><i className="check circle icon alert-success" ></i> Acuerdo subido </span>):(<span><br></br>  <i className="exclamation circle icon alert-warning"></i>  En la espera </span>)
            }
        </Typography>
        <Divider />
        <Typography
          color="textSecondary"
          variant="body2">
            {
              data.statusDocsPatente?(<span><br></br><i className="check circle icon alert-success" ></i> Pantente Subido</span>):(<span><br></br>  <i className="exclamation circle icon alert-warning"></i> En la espera </span>)
            }
        </Typography>
        <Divider />
        <Typography
          color="textSecondary"
          variant="body2"> Logo
            {
              data.statusDocsLogo?(<span><br></br><i className="check circle icon alert-success" ></i> Pantente Subido</span>):(<span> <br></br>  <i className="exclamation circle icon alert-warning"></i> En la espera</span>)
            }
        </Typography>
        <Divider />
        <Typography
          color="textSecondary"
          variant="body2">Metodo de pago
            {
            data.currentPayMethods.length <= 0?(<span><br></br><i className="check circle icon alert-success" ></i> Seleccionado</span>):(<span> <br></br>  <i className="exclamation circle icon alert-warning"></i> No seleccionado</span>)
            }
        </Typography>
        <Divider />
        <Typography
          color="textSecondary"
          variant="body2">
            {
            data.payPendings <= 0?( <span><br></br><i className="check circle icon alert-success" ></i>No posee pagos pendientes</span>):(<span> <br></br>  <i className="exclamation circle icon alert-warning"></i>$ {data.payPendings}</span>)
            }
        </Typography>
        <Divider />
        <Typography
          color="textSecondary"
          variant="body2">
            {
            data.suportTikets.length <= 0?(<span><br></br><i className="check circle icon alert-success" ></i>Todos los tickets de soporte estan cerrados</span>):(<span> <br></br>  <i className="exclamation circle icon alert-warning"></i><button>ver tickets</button></span>)
            }
        </Typography>
        <Divider />
      </Box>
    </CardContent>
     ):(<span><i className="exclamation circle icon alert-warning" ></i>Agrege los datos de su empresa</span>)}
    <Divider />
    <CardActions>

    </CardActions>
    </Card> 
    </Grid.Column>
    <Grid.Column  computer={9} mobile={16} tablet={16} className="dash-container-colmun" >
      {
      data?( <Fromcompanywiew company={data}></Fromcompanywiew>):( <Fromcompanynew porps={props} togglechildtrigres={togglechildtrigres}></Fromcompanynew>)
      }
    </Grid.Column>
    <Grid.Column  computer={4} mobile={16} tablet={16} className="dash-container-colmun" >
      {
      data?(<>
      <FileUploadRut 
        userUid={userdata.uid} 
        authorized={authorized} 
        prefix={'rut'} 
        prefixf={'companies'} 
        title={'Rut'} 
        descripcion={'Rut del representante legal de la empresa (Pdf, Jpg)'} 
        objRef='imagen' 
        companyUid={userdata.userCompanyID}
        defaultImg={data.companyImgRut}
        status={data.statusDocsRut}
        >
      </FileUploadRut>
    
      <FileUploadDocComercio    
        userUid={userdata.uid} 
        authorized={authorized} 
        prefix={'comercio'} 
        prefixf={'companies'} 
        title={'Doc. Constitutivo'} 
        descripcion={'Documento que válida si eres propietario de la empresa'} 
        objRef='imagen2' 
        companyUid={userdata.userCompanyID}
        defaultImg={data.companyImgDocsComercio}
        status={data.statusDocsComercio}
        />

      <FileUploadDocSii 
        userUid={userdata.uid} 
        authorized={authorized} 
        prefix={'docsii'} 
        prefixf={'companies'} 
        title={'Certificado SII'} 
        descripcion={'Certificado de inicio de actividades en SII (Pdf, Jpg)'} 
        objRef='imagen3' 
        companyUid={userdata.userCompanyID}
        defaultImg={data.companyImgDocsDocsii}
        status={data.statusDocsDocsii}
        />

      <FileUploadDocEbiexComercio 
        userUid={userdata.uid} 
        authorized={authorized} 
        prefix={'acuerdo'} 
        prefixf={'companies'} 
        title={'Acuerdo Comercial.'} 
        descripcion={`Acuerdo comercial firmado por tu empresa y ${siteName} (Pdf, Jpg)`} 
        objRef='imagen4' 
        companyUid={userdata.userCompanyID}
        defaultImg={data.companyImgDocsAcuerdo}
        status={data.statusDocsAcuerdo}/>

      <FileUploadPatente 
        userUid={userdata.uid} 
        authorized={authorized} 
        prefix={'patente'} 
        prefixf={'companies'} 
        title={'Patente'} 
        descripcion={'Subir Patente (Pdf, Jpg)'} 
        objRef='imagen5' 
        companyUid={userdata.userCompanyID}
        defaultImg={data.companyImgDocsPatente}
        status={data.statusDocsPatente}
        />

      <FileUploadLogo       
        userUid={userdata.uid} 
        authorized={authorized} 
        prefix={'logo'} 
        prefixf={'companies'} 
        title={'Logo'} 
        descripcion={'Subir logo (Jpg o png)'} 
        objRef='imagen6' 
        companyUid={userdata.userCompanyID}
        defaultImg={data.companyImgLogo}
        status={data.statusDocsLogo}
        />
 
       </>):(<>Agregar nueva empresa</>)
      }
    </Grid.Column>
    </Grid.Row>
    
    </Grid>
    ); 

  };

export default Companies;
